import React, { useEffect } from 'react'
import Courses from '../components/CoursesPage/Courses'

const CoursesPage = () => {

    useEffect(() => {
              window.scrollTo(0, 0);
    }, []);

  return (
    <div>
      <Courses />
    </div>
  )
}

export default CoursesPage
